import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { SITE_LOGO_ALT } from '../constants/siteBranding';
import './Header.css';

function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const closeMenu = () => setMenuOpen(false);

  return (
    <header className={`header ${scrolled ? 'scrolled' : ''} ${menuOpen ? 'menu-open' : ''}`}>
      <div className="header-container">
        <div className="logo">
          <img 
            src={`${process.env.PUBLIC_URL || ''}/KHP_LOGO.svg`}
            alt={SITE_LOGO_ALT} 
            className="logo-image"
          />
        </div>
        <button
          type="button"
          className="header-menu-toggle"
          onClick={() => setMenuOpen((o) => !o)}
          aria-expanded={menuOpen}
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
        >
          <span className="menu-icon-bar" />
          <span className="menu-icon-bar" />
          <span className="menu-icon-bar" />
        </button>
        <nav className="nav">
          <Link to="/" onClick={closeMenu}>Home</Link>
          <Link to="/about" onClick={closeMenu}>About Us</Link>
          <Link to="/services" onClick={closeMenu}>Services</Link>
          <Link to="/gallery" onClick={closeMenu}>Gallery</Link>
          <Link to="/client-reviews-ahmedabad" onClick={closeMenu}>Reviews</Link>
          <Link to="/#contact" onClick={closeMenu}>Contact Us</Link>
          <Link to="/inquiry" onClick={closeMenu}>Inquiry</Link>
          <Link to="/employee/login" onClick={closeMenu}>Portal</Link>
        </nav>
      </div>
    </header>
  );
}

export default Header;
